import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  toggle(event) {
    const item = event.currentTarget.closest("[data-faq-target='item']")
    this.itemTargets.forEach(i => {
      if (i !== item) i.classList.remove("open")
    })
    item.classList.toggle("open")
  }
}
